import AmountDisplay from '@/components/AmountDisplay';
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import { Box, Button, Stack, Typography } from '@mui/material';
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import styles from "./index.module.less";
import { useConfirm } from 'material-ui-confirm';
import { dispatch } from '@/redux/store';
import { setAmountVisible } from '@/redux/slices/assets';

export default function Header({record, userHomeData}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const confirm = useConfirm();

  const {amountVisible} = useSelector((state) => state.assets);
  const {available} = useSelector((state) => state.card)

  const _onAddCard = () => {
    navigate(RouteConstant.CARD_APPLY);
  }

  const _onManagement = () => {
    if (!record) return;

    navigate({
      pathname: RouteConstant.CARD_MANAGEMENT,
      // search: createSearchParams({
      //   cardId: record.cardId
      // }).toString()
    });
  }

  const _onDeposit = () => {
    if (!record) return;

    navigate({
      pathname: RouteConstant.DEPOSIT_VARIETY_SELECT,
      search: createSearchParams({
        cardId: record.cardId
      }).toString()
    });
  }

  const _onWithdraw = () => {
    if (!record) return;

    navigate({
      pathname: RouteConstant.WITHFRAW_VARIETY_SELECT,
      search: createSearchParams({
        cardId: record.cardId
      }).toString()
    });
  }

  const _onAvailableClick = () => {
    confirm({
      title: t("info"),
      description: t("cards_balance_available_promp"),
      hideCancelButton: true,
    });
  }

  const _onAmountVisible = () => {
    dispatch(setAmountVisible(!amountVisible))
  }

  useEffect(() => {
    if (userHomeData) {
    }
  }, [userHomeData]);

  return (
    <Box className={styles.container}>
      <Stack className={styles.info} direction="row">
        <Stack gap={'4px'} className={styles.left}>
          <Stack direction="row" alignItems="center">
            <Typography color="textSecondary" className={styles.title}>{t("available_to_spend")}</Typography>
            <RpIcon icon="info" size={14} onClick={_onAvailableClick} clickable />
          </Stack>
          <Stack direction={'row'} alignItems={'center'}>
            <Stack gap="4px" direction="row" alignItems="flex-end">
              <Typography sx={{
                lineHeight: 1,
              }}>≈</Typography>
              <AmountDisplay
                sx={theme => ({
                  fontSize: '20px',
                  fontWeight: '700',
                  lineHeight: 1,
                })}
                visible={amountVisible as Boolean} amount={available?.totalAvailable ?? '--'} />
              <Typography
                sx={theme => ({
                  lineHeight: 1,
                  fontWeight: '700',
                  paddingInlineEnd: '10px'
                })}
              >{available?.currencyCode ?? ''}</Typography>
            </Stack>
            <RpIcon size={22} icon={amountVisible ? 'eye_open' : 'eye_close'} clickable
                    onClick={() => {
                      dispatch(setAmountVisible(!amountVisible))
                    }}
            />
            {/*<RpIcon size={22} icon={amountVisible ? 'visible' : 'invisible'} clickable onClick={_onAmountVisible} />*/}
          </Stack>
        </Stack>
        <Box className={styles.right}>
          <Button variant="contained" size="small" onClick={_onAddCard}>
            <RpIcon icon="plus" size={12}/>
            &nbsp; {t("new_key")}
          </Button>
        </Box>
      </Stack>

      {/*<Box className={styles.actions}>*/}
      {/*  <Button disabled={!record} variant="contained" size="small" onClick={_onDeposit}>*/}
      {/*    <RpIcon icon="plus" size={14}/>*/}
      {/*    &nbsp; {t("plus_sign")}*/}
      {/*  </Button>*/}
      {/*  <Button*/}
      {/*    disabled={!record}*/}
      {/*    sx={theme => ({*/}
      {/*      backgroundColor: theme.palette.background.two,*/}
      {/*      color: theme.palette.text.primary*/}
      {/*    })}*/}
      {/*    variant="outlinedReverse" size="small" onClick={_onWithdraw}>*/}
      {/*    <RpIcon icon="minus_sign" size={18}/>*/}
      {/*    &nbsp; {t("return")}*/}
      {/*  </Button>*/}
      {/*</Box>*/}
    </Box>
  );
}
